<template>
  <div
    class="modal fade show d-block"
    tabindex="-1"
    role="dialog"
    v-if="mostrar"
    style="background-color: rgba(0, 0, 0, 0.5)"
  >
    <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
      <div class="modal-content shadow-sm">
        <!-- Encabezado -->
        <div class="modal-header bg-dark text-white">
          <h5 class="modal-title">
            <font-awesome-icon :icon="['fas', 'bell']" class="me-2" />
            Notificaciones del sistema
          </h5>
          <button
            type="button"
            class="btn-close btn-close-white"
            @click="$emit('update:mostrar', false)"
          ></button>
        </div>

        <!-- Cuerpo -->
        <div class="modal-body bg-light">
          <div v-if="Object.keys(alertas).length === 0" class="text-center py-5 text-success">
            <font-awesome-icon :icon="['fas', 'check-circle']" class="fa-2x mb-3" />
            <p class="mb-0 fs-5">No hay alertas activas 🎉</p>
          </div>

          <div v-else>
            <div
              v-for="(grupo, tipo) in alertas"
              :key="tipo"
              class="mb-3 border rounded"
              :style="{ borderLeft: '6px solid ' + grupoColor[tipo] }"
            >
              <button
                class="btn btn-light w-100 text-start px-3 py-2 d-flex justify-content-between align-items-center"
                @click="toggle(tipo)"
              >
                <div>
                  <font-awesome-icon :icon="grupoIcono[tipo]" class="me-2 text-secondary" />
                  <strong>{{ tipoTexto[tipo] || tipo }}</strong>
                </div>
                <span class="badge bg-danger rounded-pill">{{ grupo.length }}</span>
              </button>

              <ul
                v-show="!colapsado[tipo]"
                class="list-unstyled mb-0 small bg-white px-3 py-2"
              >
                <li
                  v-for="item in grupo"
                  :key="item.id"
                  class="alert-item d-flex align-items-start"
                >
                  <font-awesome-icon :icon="['fas', 'angle-right']" class="me-2 mt-1 text-muted" />
                  <span>{{ renderItem(tipo, item) }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <button class="btn btn-outline-secondary" @click="$emit('update:mostrar', false)">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertaModal',
  props: {
    mostrar: Boolean,
    alertas: Object
  },
  emits: ['update:mostrar'],
  data() {
    return {
      colapsado: {},
      tipoTexto: {
        stock_bajo: 'Stock Bajo',
        tareas_vencidas: 'Tareas Vencidas',
        eventos_sin_cerrar: 'Eventos No Finalizados',
        productos_sin_trazabilidad: 'Falta de Trazabilidad',
        plantas_sin_sala: 'Plantas sin Sala',
        plantas_baja_sin_biomasa: 'Plantas sin Cosecha',
        biomasa_sin_materia_prima: 'Biomasa sin Conversión',
        materia_prima_vencida: 'Materia Prima Vencida',
        producto_final_sin_envasar: 'Producto sin Envasar',
        producto_envasado_vencido: 'Producto Envasado Vencido',
        proyectos_sin_lotes: 'Proyectos sin Lotes',
        lotes_sin_plantas: 'Lotes sin Plantas'
      },
      grupoColor: {
        stock_bajo: '#5b8def',
        tareas_vencidas: '#ec6b56',
        eventos_sin_cerrar: '#f5a623',
        productos_sin_trazabilidad: '#c085ee',
        plantas_sin_sala: '#7cc6fe',
        plantas_baja_sin_biomasa: '#f18c8e',
        biomasa_sin_materia_prima: '#fac858',
        materia_prima_vencida: '#d7816a',
        producto_final_sin_envasar: '#85c1e9',
        producto_envasado_vencido: '#ffb347',
        proyectos_sin_lotes: '#8fd3f4',
        lotes_sin_plantas: '#c2c1c2'
      },
      grupoIcono: {
        stock_bajo: ['fas', 'boxes-stacked'],
        tareas_vencidas: ['fas', 'book-skull'],
        eventos_sin_cerrar: ['fas', 'calendar-xmark'],
        productos_sin_trazabilidad: ['fas', 'route'],
        plantas_sin_sala: ['fas', 'leaf'],
        plantas_baja_sin_biomasa: ['fas', 'recycle'],
        biomasa_sin_materia_prima: ['fas', 'flask'],
        materia_prima_vencida: ['fas', 'triangle-exclamation'],
        producto_final_sin_envasar: ['fas', 'box-open'],
        producto_envasado_vencido: ['fas', 'hourglass-end'],
        proyectos_sin_lotes: ['fas', 'diagram-project'],
        lotes_sin_plantas: ['fas', 'seedling']
      }
    }
  },
  methods: {
    toggle(tipo) {
      this.colapsado = {
        ...this.colapsado,
        [tipo]: !this.colapsado[tipo]
      }
    },
    renderItem(tipo, item) {
      switch (tipo) {
        case 'stock_bajo': return `${item.nombre}: ${item.cantidad}/${item.nivel_minimo}`
        case 'tareas_vencidas': return `${item.titulo} - ${item.fecha}`
        case 'eventos_sin_cerrar': return `${item.evento_cultivo?.nombre_evento} (${item.proyecto?.nombre})`
        case 'plantas_sin_sala': return `Planta ${item.codigo} sin sala`
        case 'plantas_baja_sin_biomasa': return `Planta ${item.codigo} sin cosecha`
        case 'biomasa_sin_materia_prima': return `Biomasa ${item.codigo} sin materia prima`
        case 'materia_prima_vencida': return `${item.codigo} vencida el ${item.fecha_vencimiento}`
        case 'producto_final_sin_envasar': return `${item.codigo} sin envase`
        case 'producto_envasado_vencido': return `Envase ${item.codigo} vencido`
        case 'productos_sin_trazabilidad': return `Producto ${item.codigo} sin trazabilidad`
        case 'proyectos_sin_lotes': return `Proyecto ${item.nombre} sin lotes`
        case 'lotes_sin_plantas': return `Lote ${item.codigo} sin plantas`
        default: return '⚠️ Alerta detectada'
      }
    }
  },
  mounted() {
    for (const tipo in this.alertas) {
      this.colapsado[tipo] = true; // Iniciar todos colapsados
    }
  }
}
</script>

<style scoped>
.modal {
  display: block;
  z-index: 1050;
}
.alert-item {
  padding: 6px 8px;
  margin-bottom: 4px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}
.alert-item:hover {
  background-color: #f8f9fa;
  cursor: pointer;
}
</style>
